module.exports = __webpack_public_path__ + "static/heroTeal-c562106cff50479b645df35ceb765f14.gif";